import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4a02fd4e&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=4a02fd4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02fd4e",
  null
  
)

export default component.exports